/**
 * Resolve a rota de abertura de curso/trilha com base no type da API (home/v2, busca, etc.).
 * COURSE → nova tela de conteúdo (/turma/curso/:id via proxy)
 * TRAIL → layout legado (/curso-novo/:id)
 */

export const COURSE_CONTENT_TYPE = {
  COURSE: 'COURSE',
  TRAIL: 'TRAIL',
};

function isTrailType(courseType, courseId) {
  if (courseType === COURSE_CONTENT_TYPE.TRAIL) return true;
  if (courseType === COURSE_CONTENT_TYPE.COURSE) return false;
  return typeof courseId === 'string' && courseId.startsWith('TRAIL_');
}

function isCourseType(courseType, courseId) {
  if (courseType === COURSE_CONTENT_TYPE.COURSE) return true;
  if (courseType === COURSE_CONTENT_TYPE.TRAIL) return false;
  return typeof courseId === 'string' && courseId.startsWith('COURSE_');
}

/**
 * @returns {string|null} pathname relativo (sem origin)
 */
export function getCoursePathname(courseId, courseType) {
  if (!courseId) return null;

  if (isTrailType(courseType, courseId)) {
    return `/curso-novo/${courseId}`;
  }

  if (isCourseType(courseType, courseId)) {
    return `/turma/curso/${courseId}`;
  }

  // Retrocompat: sem type conhecido, vai para a nova tela de curso
  return `/turma/curso/${courseId}`;
}

export function isNewCoursePagePath(pathname) {
  return typeof pathname === 'string' && pathname.startsWith('/turma/curso/');
}

/**
 * Navega para o curso/trilha correto.
 * Rotas /turma/* exigem full-page navigation (projeto Next via proxy).
 */
export function navigateToCourse(courseId, courseType, options = {}) {
  const { history, object, state, useReplace = false } = options;
  const pathname = getCoursePathname(courseId, courseType);

  if (!pathname) return;

  if (isNewCoursePagePath(pathname)) {
    window.location.href = `${window.location.origin}${pathname}`;
    return;
  }

  const routeState = state != null ? state : (object ? { object } : undefined);

  if (history) {
    const navigate = useReplace ? history.replace : history.push;
    navigate({ pathname }, routeState);
    return;
  }

  window.location.href = pathname;
}
